import { useContext } from 'react';

import { CtPlatform } from 'models/general';
import { StoreContext } from 'models/import';
import Header, { HeaderProps } from 'components/header';

function ImportPlatformHeaderComponent() {
  const { platform } = useContext(StoreContext);

  const mapHeaderData = (p?: CtPlatform): HeaderProps | undefined => {
    if (!p) { return undefined; }

    return {
      backLink: true,
      headline: p.display_name || '',
      title: 'Import trades',
      desc: p.description || '',
      logoUrl: p.logo_uri || '',
    } as HeaderProps;
  };

  const headerData = mapHeaderData(platform);

  if (!headerData) return null;

  return (
    <Header {...headerData} />
  );
}

export default ImportPlatformHeaderComponent;
